// 国家站点类
class NationalSite {
  constructor(name, abbreviation, currency, currencyAbbreviation, 
    currencySymbol, taxBaseType, dutyTaxBaseType, withholdingRatio){
    // 国家站点名称
    this.name = name
    // 对应缩写
    this.abbreviation = abbreviation
    // 货币
    this.currency = currency
    // 货币缩写
    this.currencyAbbreviation = currencyAbbreviation
    // 货币符号
    this.currencySymbol = currencySymbol
    // 增值税税基类型
    this.taxBaseType = taxBaseType
    // 关税税基类型
    this.dutyTaxBaseType = dutyTaxBaseType
    // 代缴比例
    this.withholdingRatio = withholdingRatio
  }
}

let countrySite = {
  USA: new NationalSite('美国站', 'USA', '美元', 'USD', '$', 'NONE', 'FOB', 100),
  Canada: new NationalSite('加拿大站', 'CAN', '加元', 'CAD', 'CA$', 'CNF', 'FOB', 100),
  UK: new NationalSite('英国站', 'UK', '英镑', 'GBP', '￡', 'CNF', 'CNF', 100),
  Germany: new NationalSite('德国站', 'GER', '欧元', 'EUR', '€', 'CNF', 'CNF', 100),
  France: new NationalSite('法国站', 'FRA', '欧元', 'EUR', '€', 'CNF', 'CNF', 100),
  Italy: new NationalSite('意大利站', 'ITA', '欧元', 'EUR', '€', 'CNF', 'CNF', 100),
  Spain: new NationalSite('西班牙站', 'ESP', '欧元', 'EUR', '$', 'CNF', 'CNF', 100),
  Japan: new NationalSite('日本站', 'JPN', '日元', 'JPY', 'JP¥', 'CNF', 'CNF', 0),
  Australia: new NationalSite('澳洲站', 'AUS', '澳元', 'AUD', 'AU$', 'CNF', 'FOB', 0),
  Mexico: new NationalSite('墨西哥站', 'MEX', '比索', 'MXN', 'MX$', 'CNF', 'CNF', 100),
}

// 国家货币
let countryCurrencyInvariant = Object.keys(countrySite).map(key => countrySite[key].currency)
// 国家货币缩写
let countryAbbreviationInvariant = Object.keys(countrySite).map(key => countrySite[key].currencyAbbreviation)
// 国家缩写
let countryAbbreviationInvariantByFinancial = Object.keys(countrySite).map(key => countrySite[key].abbreviation)
// 国家货币符号
let nationalCurrencyInvariant = Object.keys(countrySite).map(key => countrySite[key].currencySymbol)
// 英美制长度
let lengthArrayInvariant = ['cm', 'inch']
// 英美制重量
let weightArrayInvariant = ['kg', 'lb']
// 会员会费
let warehouseFee = ['39.99','49.95','25.00','22.00','22.00','22.00','22.00','4900','49.95','49.95']
// 欧洲国家索引
let europeIndexArray = [2, 3, 4, 5, 6, 8, 9]
// 欧美国家索引
let europeAndAmericaIndexArray = [0, 1]
// 日本、澳洲国家索引
let aisaIndexArray = [7]
// 产品状态
let productStatusInputOptions = ['不带电池', '带内置电池', '带外置电池', '不带磁性', '带磁性', '纯磁', '含液体', '含粉末', '含膏体'];
/** 物流API对应产品状态 */
let productStatusByLogistics = ['带内置电池(不带磁性)', '带外置电池(不带磁性)', '带内置电池(带磁性)', '不带电池不带磁性', '带外置电池(带磁性)', '不带电池(带磁性)', '纯电(充电宝,手机电池,碱性电池等)', '纯磁;(可以填写多个用,隔开 如：3,4,5)']
/**权限对应账户名称 */
let permissionNameObj = {
  ROLE_TEST: '免费会员',
  ROLE_DEFAULT: '基础会员',
  ROLE_PRO: 'PRO会员',
  ROLE_ADMIN: '管理员',
  ROLE_NEWS_ADMIN: '文章管理员',
  ROLE_BOSS: 'BOSS',
}

// 卖家账户类型输入框详情
let sellerTypeInputHtml =
  `<p>亚马逊卖家分为“专业销售计划”及“个人销售计划”卖家。(说明: 美国亚马逊“专业销售计划帐户”收费为每月$39.9，销售佣金另外计算；美国亚马逊“个人销售计划帐户”收费为$0,但每套商品销售后收$0.99,销售佣金另外计算;其它不同区域帐户收费类似）；</p>
  <br>
  <p>补充: 早前,亚马逊帐户分不同的区域帐户: 例如”北美区域帐户”包括美国,加拿大及墨西哥站点;“欧盟区域帐户”包括德国，法国，西班牙，意大利站点; 英国脱欧后自成一”英国区域帐户;日本与澳洲是另外两个独立的“日本区域帐户”及“澳洲区域帐户”，不同区域帐户各自收不同的卖家帐户月费；</p>
  <br>
  <p>但最近亚马逊实施了新政策, 对于“专业销售计划帐户”,所有不同的国家合并为1个卖家帐户,统一只收$39.99月租费；但要注意的是,不同国家站点的帐户要合并设置后才能享受统一只收$39.99月租费；</p>
  <br>
  <p>“个人销售计划帐户”,收费保持不变；</p>
  <br>
  <p>备注：该项费用的分摊计算方法: 按整个卖家帐户的总销量来分摊到该商品上。</p>
  <span>例如：该卖家帐户当月所有不同商品的总销量为100,那么该项费用将除以100计算该商品的分摊成本。</span>`
// 合仓设置输入框详情
let warehouseConfigurationInputHtml =
  `<p>当货物有N箱进行亚马逊FBA入仓计划时,亚马逊可能对该批货物安排进入N个不同仓库，这样导致的结果是您将需要将该批货物分为N批次货物各自发运到不同的仓库地址,国际物流运费成本及安排发运的操作成本自然地将大大增加。</p>
  <br>
  <p>为解决这个问题,亚马逊相应地提供”合仓配置“的功能,让该批货物可以合并发到同一个亚马逊仓库,但同时亚马逊将针对“该批货物中的每一个商品收取”合仓配置费”。根据不同的商品分类,及其尺寸,重量,类型等分为标准件,大件,超大件等收取不同的”合仓配置费”。</p>
  <br>
  <p>我们系统已根据您录入的商品信息,智能分析及计算出每套商品的”合仓配置费”,放请心使用。</p>
  <br>
  <p>温馨提示:每次发货的箱数不同,亚马逊将货物分配到多少个不同仓库难以确定,这个通常做了进仓计划后才有确切数据。理论上卖家可根据两种情况下的“国际物流运费差”对比“该批货物被收取的总合仓配置费”才能确认那个更划算。但实际上,合仓与不合仓设置得不断重设置,同时进仓计划要不停地放弃,这样会影响亚马逊店铺的绩效分数。因此我们不建议合仓设置经常切换。当然,只有一两箱货物做进仓计划时通常会安排到同一个仓库;视情况而定,对于不同的货物,卖家如果有时间可计算比较一下！</p>
  <br>
  <p>对于初级卖家,建议为了简单操作，设置为合仓为宜！</p>`
// 独立网络等运营月费输入框详情
let otherFeeInputHtml =
  `<p>"网络/软件月费" 泛指"独立IP网络使用月费","店铺销售运营软件月费"及其它工具软件月费等(如果不产生该任何此类费用, 可在单元格内录入0);</p>
  <br>
  <p>计算公式：网络/软件月费(按占比) = 店铺网络使用月费及运营软件月费等× 该款商品占网络/软件月费的百分比</p>
  <br>
  <p>情况参考：</p>
  <p>情况A (只销一款): 若店铺仅销售该款商品(占比100%)，请在单元格直接输入店铺真实的"网络/软件月费"总额;  </p>
  <br>
  <p>(但"只销一款"通常为运营初期, 月销量如果不大, 分摊到单品的"网络/软件月费"将较大, 因此可暂时忽略"网络/软件月费", 直接输入0查看分析单品的成本与利润的变化)。</p>
  <br>
  <p>情况B (销售多款)：若店铺销售多款不同商品,且每款销量都很大,单款分摊的比例极低(趋近于0%)，此时您可以直接输入0。</p>`
// 卖家帐户月均财务费输入框详情
let taxExpenseInputHtml =
  `<p>欧洲的税务合规要求非常严格,通常亚马逊卖家的商品入欧盟成员国及英国的亚马逊仓库并进行销售时都需要申请注册当地公司及税号(欧盟成员国及英国当地个人卖家在一定的年销售总额下例外)并通过专业的会计师做帐,年审,报税等。因此产生通常按年收取的财务费,。本系统按月分摊将产生"每月财务费”;</p>
  <br>
  <p>(备注:英国每3个月一次,1年共4次VAT申报, 意大利及西班牙每季节1次,年度1次,共5次VAT申报,法国每月1次,1年共12次VAT申报;例如财务公司对英国帐户每年收取的做帐及VAT申报等财务费为￥12000;即卖家帐户月均财务费为￥1000;</p>
  <br>
  <p>此项费用通常适用于英国及其它欧盟成员国;美国,加拿大,日本,澳洲等国家通常不涉及此项费用,但视实际情况而定,可按店铺实际情况录入每月财务费);</p>
  <br>
  <p>请根据该商品销售的国家站点及销售状况进行评估：</p>
  <p>计算公式：每月财务费(按占比) = 店铺每年财务费/12 × 该款商品占每月财务费的百分比</p>
  <br>
  <p>情况参考：</p>
  <p>情况A (只销一款): 若店铺仅销售该款商品(占比100%)，请在单元格直接输入店铺真实的"每月财务费"总额;  </p>
  <br>
  <p>(但"只销一款"通常为运营初期, 月销量如果不大, 分摊到单品的"每月财务费"将较大, 因此可暂时忽略"每月财务费", 直接输入0查看分析单品的成本与利润的变化)。</p>
  <br>
  <p>情况B (销售多款)：若店铺销售多款不同商品,且每款销量都很大,单款分摊的比例极低(趋近于0%)，此时您可以直接输入0。</p>`
// 店铺管理人力成本输入框详情
let laborCostForStoreManagementInputHtml =
  `<p>请根据您店铺的实际人员架构（销售、运营、管理等）及销售状况进行估算：</p>
  <p>计算公式：每月人力成本(按占比) = 店铺每月总人力成本 × 该款商品占每月总人力成本的百分比</p>
  <br>
  <p>情况参考：</p>
  <p>情况A (只销一款): 若店铺仅销售该款商品(占比100%)，请在单元格直接输入店铺真实的"每月人力成本"总额;  </p>
  <br>
  <p>(但"只销一款"通常为运营初期, 月销量如果不大, 分摊到单品的"每月人力成本"将较大, 因此可暂时忽略"每月人力成本", 直接输入0查看分析单品的成本与利润的变化)。</p>
  <br>
  <p>情况B (销售多款)：若店铺销售多款不同商品,且每款销量都很大,单款分摊的比例极低(趋近于0%)，此时您可以直接输入0。</p>`
// 资金运营年息率输入框详情
let operatingAnnualInterestRateInputHtml =
  `<p>该年息率用于计算亚马逊采购及物流等的资金运营成本。该项为预设值，如不涉及该项运营成本,可设置为0.0%，如要修改，请先登录店铺后台并在“设置/店铺与帐户设置”目录页内进行预设置，对应数据才会在此自动导出。</p>`
// 商品售价
let sellingPriceInputHtml =
  `<p>亚马逊卖家商品售价说明：</p>
  <br>
  <p>商品销售价(美国站)：</p>
  <p>* 后台设置的商品售价：不含税净价;</p>
  <p>* Sales Tax谁付：买家在结账时额外支付 Sales Tax;</p>
  <p>* 亚马逊怎么处理：亚马逊代收后直接交给州税务局，钱不进卖家账户;</p>
  <br>
  <p>商品销售价(英国站/德国站等欧盟国家站点)</p>
  <p>* 后台设置的商品售价：含VAT总价;</p>
  <p>* Sales VAT谁付：买家支付的就是含税总价，VAT已包含在里面;</p>
  <p>* 亚马逊怎么处理：亚马逊从总价中拆出VAT代缴，净价部分结算给卖家;</p>
  <br>
  <p>您在亚马逊卖家后台如常放心录入商品售价就可, 以上仅说明区别让您运营更清淅。我们的计算系统会为您保驾护航，自动分辨及正确计算利润。</p>`
// 是否出口退税输入框详情
let xxtsInputHtml =
  `<section data-role="outer" label="Powered by 135editor.com" style="">
  <p>指"基于以下采购数量"的该批商品是否进行独立报关/出口退税；</p>
  <p>注: 1. 独立报关才能进行出口退税; 2. 当选择独立报关及出口退税，国际物流公司通常就只提供"双清不包税"的跨境物流服务，且需要您提供目的国个人或公司的税号进行清关缴税。</p>
  </section>`
// 清关及缴税状况输入框详情
let sqbsInputHtml =
  `<section data-role="outer" label="Powered by 135editor.com" style="">
  <p>指"基于以下采购数量"的该批商品是否进行独立报关/出口退税；</p>
  <p>注: 1. 独立报关才能进行出口退税; 2. 当选择独立报关及出口退税，国际物流公司通常就只提供"双清不包税"的跨境物流服务，且需要您提供目的国个人或公司的税号进行清关缴税。</p>
  </section>`
// 采购单价输入框详情
let stockPriceInputHtml =
  '对于贸易公司或个人，这里就是产品的采购单价；对于生产厂家，这里可以理解为产品的出厂单价；'
// 采购数量输入框详情
let stockNumInputHtml =
  '对于贸易公司或个人，这里就是产品的采购数量；对于生产厂家，这里可以理解为产品的生产数量；'
// 国内段总运费输入框详情
let domesticFreightInputHtml =
  `<p>指基于以上采购数量,该批商品自己安排发货而产生的国内段运费; 如果国际货运公司免费上门收件,该国内总运费可视为0,在单元格数据可输入0即可；</p>
  <br>
  <p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p>`
// 国际段总运费输入框详情
let internationFreightInputHtml =
  `<p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span>
  <br>
  备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p>`
// 海关申报单价输入框详情
let saleTaxInputHtml =
  '海关申报单价主要用于目的港清关,根据货物申报价值计算目的国入口关税等;'
// 货物入口税费输入框详情
let sqrkgslInputHtml =
  '由于商品的多样性及复杂性,即使出口国对该商品归类为某对应的商品海关编码(HS CODE),但终究以进口国对该进口商品进行审核及判断商品的归类及价值, 因此商品入口关税难以100%确认。当然用户可以试归类对应HS Code及关税率，先预估入口关税额；如果该商品曾经出口，可咨询清关代理确认当时的入口关税率直接在此录入即可；<br><br>对于某些国家清关核准很严谨, 例如日本及韩国, 因此该国家只提供双清不包税物流渠道，入口关税只按实报实销原则向货主收取(如果该商品曾经出口该国家, 您可按物流公司或清关代理之前的实收金额推算出关税率后输入单元格即可)。对于DDP双清包税的物流渠道,由于已包含清关关税,这种情况下可以在单元格内输入0。<br><br>特别注意：由于美国在MFN关税的基础上加征Section 301 (List 3)关税以及强迫劳动 301关税,用户可通过AI咨询对应的出口产品是否涉及以上情况,最终确认并在单元格内输入综合关税率即可。'
// 当月站内广告费输入框详情
let advertisingFeeInputHtml =
  `<p>指“该商品当月的”亚马逊站内的点击广告费”;可在亚马逊后台“广告管理”内查询该商品的当月点击广告费用。如不涉及这项费用,在单元格数据可以输入0；</p>`
// 当月站外测评费输入框详情
let billingFeeInputHtml =
  `<p>指该商品当月亚马逊站外的“测评实际损耗”(此测评基于商品免费提供及不回收的情况）。</p>
  <br>
  <p>“当月站外测评费”的参考计算公式：当月站外测评费 = （该商品的采购成本 + 国内单位运费 + 国际单位运费 + 合仓配置费 + 当地运费 + 亚马逊佣金 + 测评服务费）* 该商品的测试数量；</p>
  <br>
  <p>如果商品有其它不同的测评方式，例如：不同的留评比率或可回收商品等,请根据您的实际情况输入相应的当月站外测评费);如不涉及这项提成,可以输入0；</p>`
// 当月站外引流费输入框详情
let drainageFeeInputHtml =
  `<p>指由亚马逊站外的渠道推广引流的月费，例如通过Facebook, Google或其它网站的点击广告或其它运营操作引流到该亚马逊在售商品所产生的费用;如不涉及这项费用,可以输入0；</p>`
// 商品销售提成率输入框详情
let salesCommissionInputHtml =
  `<p>指基于"商品售价"的销售提成率（此项是为店铺销售人员设置的对于当前商品的销售提成率；此项为预设置项，如不涉及该项提成,可设置为0.0%，如要修改，请先登录店铺后台并在“设置/商品销售提成设置”目录页对应修改更新);</p>`
// 运营管理提成率输入框详情
let operationCommissionInputHtml =
  `<p>指也是基于“商品售价”的运营管理提成率（此项是为“亚马逊多店铺运营管理人员”设置的针对“所有店铺商品”“统一的销售提成率”；如您的亚马逊销售体量较大，已涉及运营管理人员，或者您的亚马逊是通过代运营管理，可以考虑设置该项提成；此项为预设置项，如不涉及该项提成,可设置为0.0%，如要修改，请先登录店铺后台并在“设置/店铺及费用设置”目录页对应修改更新);</p>`
// 亚马逊销售佣金率输入框详情
let commissionInputHtml =
  `<p>指亚马逊对商品抽取的“销售佣金率”（此项为预设置项，如要修改，请先到“销售/Listing管理”目录页查找对应商品信息进行“商品销售佣金率”的修改更新);</p>`
// 收汇损失率输入框详情
let recoveryLossRateInputHtml =
  `<p>本系统基准汇率对接的是中国银行现汇买入价（现实中对接不了Payoneer或PingPong等），该汇率已包含中国银行结汇收益的点差（即当前汇率对应的汇损已包含在内，可理解为汇损率为0%）；</p>
  <br>
  <p>但亚马逊收款一般通过Payoneer、PingPong等第三方通道，这类通道结汇汇率通常低于中国银行。例如，根据2026年10月25日中国银行美金兑人民币的汇率6.6606，Payoneer为6.645，汇损率计算公式：(6.6606 − 6.6443) ÷ 6.6606 ≈ 0.245%。</p>
  <br>
  <p>（注：实操中请参考本系统当天的美金与人民币的汇率，以及你自己当天在Payoneer或PingPong的结算汇率代入到上面的公式自行计算，得出的比率直接输入到汇损率输入框即可，无需频繁变更，一段时间后可重新验证计算。或根据我们以上的实际内测数据，粗略地录入0.25%也可)。</p>`
// 当月显示销量输入框详情
let showSalesInputHtml =
  '<section data-role="outer" label="Powered by 135editor.com" style=""><p>可根据这个路径:“亚马逊后台/数据报告/业务报告/根据ASIN及日期筛选及查询显示的销售量”</p><br><p>注意:</p><p style="margin-left:0;text-indent:0">1. 商品销售量与订单量不同,1个订单可能有N个商品；</p><p style="margin-left:0;text-indent:0">2. 在显示商品Listing销售量的页面,有些订单是坏品弃置的记录单,注意辨识及减除；</p><br><p>我们系统内还有另外一项“当月实际销量”，当月实际销量 = 当月销量 - 当月坏品退货数 - 当月非坏品退货数</p></section>'
// 当月坏品退货数输入框详情
let disposalNumInputHtml =
  `<p>坏品退货数查询路径：</p>
  <p style="margin-left:0;text-indent:0">1. 亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板 / 管理亚马逊物流退货; 或</p>
  <p style="margin-left:0;text-indent:0">2. 亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货;</p>
  <br>
  <p>通过对应的国家,ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Customer Damaged买家导致的残损”及“Defective存在瑕疵”的坏品的总退货数量,在单元格输入即可)；</p>
  <br>
  <p>(备注:商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“买家导致的残损”及“存在瑕疵”,商品将在一定天数后才安排坏品弃置。</p>
  <br>
  <p>补充：1 套 “库存属性” 定性为 “买家导致的残损” 及 “存在瑕疵” 的坏品退回的实际损失= 采购单价 + 国内单位运费 + 国际单位运费 + 入口关税 + 资金运营利息 + 单位合仓配置费 + 单位仓储成本 + 亚马逊卖家账户月费分摊 + 月广告费分摊 + 月测评费用分摊 + 站外引流费用分摊 + 当地配送费 + 亚马逊销售佣金*20%)</p>`
// 当月非坏品退货数输入框详情
let returnNumInputHtml =
  `非坏品退货数查询路径：<br>1.亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板/管理亚马逊物流退货；
  <br>
  2.亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货；
  <br>
  <br>
  通过对应的国家、ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Sellable可售”的非坏品的总退货数量，在单元格输入即可)；
  <br>
  <br>
  (备注: 商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“Sellable可售”，商品将会被亚马逊重新安排上架及作为Used二手货物降价，以跟卖的方式销售)。
  <br>
  <br>
  补充：
  <br>
  1套“Sellable可售”的非坏品退货的实际损失 = 仅退商品销售佣金部分的80% + 当地配送运费不退 + 25% * 商品售价 + 退货处理费；(备注：1. 此项计算基于粗略假设亚马逊将商品降价25%重新上架销售；2. 每个品类都有一个特定的退货率阈值(如美妆 5.5%,汽车用品 9.1%)。如果计算出的退货率没有超过这个阈值,那么将不触发退货费; 本系统暂时假设退货处理为0代入计算,因为如果该商品退货率超过阈值产生大量的退货时可说明该商品没竞争力或引起亏损,再计算利润已没意义)。`
// 当月弃置移除数量输入框详情
let dyqzycslInputHtml =
  `<p>备注：由于亚马逊的区域移除报告不提供对应的国家站点数据，该单元格取值按“区域移除数据报告”对应的的这个ASIN的移除数量除以“该区域已开通的国家站点的数量”；数据默认进位为整数；</p>`
// 商品当前库存量输入框详情
let positionDayInputHtml =
  `<p>根据这个链接: <a href="https://sellercentral.amazon.com/inventory">https://sellercentral.amazon.com/inventory</a>;或根据这个路径: 亚马逊后台 / 库存 / 对应商品的ASIN查询该商品的当前库存数量即可。</p>`
  // 当月赔偿回款输入框详情
let dybpcslInputHtml =
  `<p>赔偿回款查询路径：亚马逊后台/付款/交易一览/交易类型: 选择当月的:Inventory Reimbursement</p>`
// 亚马逊销售佣金输入框详情
let getAmazonSalesCommissionInputHtml =
  `<p>根据商品原始数据里输入的亚马逊佣金率及商品售价,计算所得的单位商品的销售佣金。</p>`
// 当地配送费输入框详情
let getLocalDeliveryFeeInputHtml =
  `<p>
    指亚马逊根据不同商品分类,重量,体积等计算得出的当地运费。
  </p>
  <p>
    备注：您可以在后台商品Listing里查看显示的当地运费跟我们系统计算出的运费是否一致；如果不一致,请注意较对您刚才输入的商品尺寸,重量,分类,跟您在亚马逊后台商品Listing里已上传的对应项数据是否一致）；
  </p>`
// 仓储费用分摊输入框详情
let getStorageCostAllocationInputHtml =
  `<p >
    系统根据商品的分类，体积，重量，淡旺季不同的每CBM仓储价格，每套商品的平均待仓天数，库存的数量等计算出单位商品的仓储费用。
  </p>`
// 合仓设置费输入框详情
let getWarehouseConsolidationSettingFeeInputHtml =
  `<p>
    对货物做FBA亚马逊入仓计划时，亚马逊可能对该批货物安排到N个不同仓库进仓，这样导致的结果是您将需要将该批货物分为N批货单独发运到不同的仓库地址，国际物流运费成本及安排发运的操作成本将大大增加。
  </p>
    &nbsp;
  </p>
  <p>
    如果通过亚马逊合仓设置,该批货物将可以合并发到同一个亚马逊仓库,但同时亚马逊将针对“该批货物中的每一个商品收取合仓设置费用”。
  </p>
  <p>
    &nbsp;
  </p>
  <p>
    不同的商品，根据其尺寸，重量，类型等，将分为标准件，大件，超大件等，收取不同的合仓配置费用。我们已根据商品信息，智能分析及计算出每套商品的合仓配置费用，放请心使用。
  </p>`
// 收汇损失输入框详情
let getCollectionLossInputHtml =
  `<p>
    单位商品收汇损失 ＝ (单位商品销售额 - 单位商品亚马逊总费用）* 收汇损失率
  </p>
  <p>
    &nbsp;
  </p>
  <p>
    (备注：单位商品亚马逊总费用 = 单位商品的亚马逊销售佣金 + 亚马逊当地运费 + 亚马逊卖家帐户月费分摊 + 月广告费用分摊 + 坏品退货损耗分摊 + 仓储费用分摊 + 合仓配置费分摊）
  </p>`
// 资金运营利息输入框详情
let getFundOperationInterestInputHtml =
  `<p>
  单位商品资金运营利息 = [ 单位商品出资成本 * （生产数量 + 运输数量 + 当月商品显示销量 + 当月商品库存数量）* 资金运营年息率/12 ] / 当月实际销量;
  </p>
  <p>
  (备注: 一个亚马逊FBA商品实际的运营所需的供应量粗略地由4部分组成: 生产数量，运输数量，当月销量，当月库存量；其中采购数量，运输数量及当月库存量被粗略地视作相等)
  </p>`
// 商品出资成本输入框详情
let getCostOfCommodityInvestmentInputHtml =
  `<p >
    商品出资成本 = 采购单价 + 国内单位运费 + 国际单位运费 + 商品入口关税（Duty）+ 商品月测评费分摊 + 站外月引流费用分摊 + 独立网络等运营月费分摊 + 卖家帐户月均财务费用分摊；
  </p>
  <p>
    &nbsp;
  </p>
  <p>
    (以上8项为每单位的亚马逊FBA商品实际出资成本。其它的费用都在亚马逊帐户销售款中扣取,不需要卖家额外出资)。
  </p>`
// 商品收汇输入框详情
let getCommodityCollectionInputHtml =
  `<p>
    指每单位商品销售后扣除亚马逊所有费用后的剩余金额。
  </p>
  <p>
    &nbsp;
  </p>
  <p>
    (备注：单位商品的亚马逊费用包括：亚马逊销售佣金，亚马逊当地运费，卖家帐户月费分摊及月广告费用分摊(该两项费用在“帐户设置”内通常默认设为直接在销售款内扣费,不在信用卡扣费),坏品退货损耗分摊,非坏品退货损耗,仓储费用分摊,合仓配置费以及收汇损失分摊后的实际收汇。
  </p>`
// 当月实际销量输入框详情
let getActualSalesVolumeForTheMonthInputHtml =
  `<p >
    当月实际总销量 = 商品当月显示销量 - 当月坏品退货数 - 当月非坏品退货数。
  </p>
  <p>
    &nbsp;
  </p>
  <p>
    补充说明：无论是非坏品或坏品退货，都可能是客户当月或N月前购买但当月退回的商品;
  </p>
  <p>
    这两类退货商品的总数量存在跨月退回的问题。所以可以简单地将“实际销量&quot; 理解为显示销售出去的商品数量减去退回来的坏品及非坏品数量&quot;。
  </p>`
// 当月销售利润率输入框详情
let getMonthlySalesProfitMarginInputHtml =
  `<p>
    当月销售利润率 = （商品净利润/商品售价）* 100%
  </p>`
// 当月成本利润率输入框详情
let getMonthlyCostProfitMarginInputHtml =
  `<p>
  当月成本利润率 = （商品净利润/成本汇总）* 100%
  </p>`
// 商品入口关税
let getImportTariffsOnGoodsInputHtml = 
  `<p style='font-weight: bold;'>商品入口关税 (Import Duty): </p>
  <br>
  <p style='font-weight: bold;'>1. 以CIF或CNF为入口关税税基的亚马逊国家站点:</p>
  <p>(当国际运输没购买国际保险,海关也接受CNF)</p>
  <p>&nbsp;&nbsp;* 欧洲：英国、德国、法国、意大利、西班牙、荷兰、瑞典、波兰、比利时、爱尔兰</p>
  <p>&nbsp;&nbsp;* 亚太：日本、印度、新加坡</p>
  <p>&nbsp;&nbsp;* 中东：阿联酋、沙特阿拉伯、埃及</p>
  <p>&nbsp;&nbsp;* 美洲：墨西哥、巴西</p>
  <br>
  <p> # 以CIF为关税税基计算</p>
  <p>&nbsp;&nbsp;&nbsp;商品入口关税 (Import Duty) = CIF货值 * 关税率 </p>
  <p>&nbsp;&nbsp;&nbsp;(CIF货值 = 出口国申报货值 + 国际运费 + 国际保险)</p>
  <br>
  <p># 本系统以CNF为入口关税税基计算(本系统以CNF为关税税基计算):</p>
  <p>&nbsp;&nbsp;&nbsp;商品入口关税 (Import Duty) = CNF货值 * 关税率</p>
  <p>&nbsp;&nbsp;&nbsp;(CNF货值 = 出口国申报货值  +  国际运费)</p>
  <br>
  <p style='font-weight: bold;'>2. 以FOB为关税税基的亚马逊国家站点：</p>
  <p>&nbsp;&nbsp;&nbsp;* 美国站</p>
  <p>&nbsp;&nbsp;&nbsp;* 加拿大站</p>
  <p>&nbsp;&nbsp;&nbsp;* 澳大利亚站</p>
  <p>&nbsp;&nbsp;&nbsp;* 新西兰站</p>
  <p>&nbsp;&nbsp;&nbsp;* 南非站（2024年新开站点）</p>
  <br>
  <p># 以FOB为关税税基计算:</p>
  <p>&nbsp;&nbsp;商品入口关税 = FOB货值 * 关税率 </p>
  <p>&nbsp;&nbsp;(FOB货值 = 出口国申报货值)</p>`
// 商品入口销售增值税(Import VAT)
let getSalesVATOnGoodsInputHtml =
  `<p style="font-weight: bold;">Import VAT/GST/JCT/IVA:</p>
  <br>
  <p style="font-weight: bold;">1. 以"CIF或CNF货值"为"Import VAT/GST/JCT/IVA”税基的亚马逊国家站点:</p>
  <p>&#9;* 加拿大, 澳大利亚, 新西兰</p>
  <p style="font-weight: bold;">&#9;# 本系统忽略其它杂费, 以"CNF货值"为"Import VAT/GST/JCT/IVA”税基计算:</p>
  <p>&#9;Import VAT/GST/JCT/IVA = CNF货值 * VAT/GST/JCT/IVA税率</p>
  <p>&#9;(CNF货值 = 出口国申报货值 + 国际运费)</p>
  <br>
  <p style="font-weight: bold;">2. 以"CIF或CNF货值+Import Duty+其它杂费"作为"Import VAT/GST/JCT/IVA"税基的亚马逊国家站点:</p>
  <p>&#9;* 日本：进口消费税(Import JCT)的计税基础是CIF货值加上关税及个别消费税等。</p>
  <p>&#9;* 墨西哥：进口增值税(Import IVA)的计税基础通常基于CIF货值加上关税等其他费用。</p>
  <p>&#9;* 英国及欧盟成员国：进口增值税(Import VAT)的计税基础通常基于CIF货值加上关税等其他费用。</p>
  <br>
  <p style="font-weight: bold;">&#9;# 本系统忽略其它杂费, 以"CNF货值+Import Duty"为VAT/GST/JCT/IVA税率"税基计算:</p>
  <p>&#9;Import VAT/GST/JCT/IVA = CNF货值 * VAT/GST/JCT/IVA税率</p>
  <p>&#9;(CNF货值 = 出口国申报货值 +国际运费)</p>
  <br>
  <p style="font-weight: bold;">备注：</p>
  <p>&#9;* 美国清关环节, 没有类似欧盟的ImportVAT、澳洲的Import GST那种在清关时同步征收的入口销售税(Import Sales Tax),不需要在清关阶段考虑税基及计算入口销售税。</p>`
// 清关杂费(ADV)
let getCustomsClearanceMiscellaneousFeesInputHtml = `金额较小,暂时忽略,暂可视为￥0.00`
// 退税输入框详情
let getTaxRefundInputHtml =
  `<p style="font-weight: bold; color: #00a0c7;">第一种情况: 当货物入口关税Import VAT申请递延</p><br>
  <p>正常情况时, 销售价将高于商品入口申请价值；</p>
  <p>"Sale VAT=Sale Price * VAT Rating" 大于 "Import VAT = Import Price * VAT Rating";</p>
  <p>由于Import VAT申请了递延，即缴纳的Import VAT=0；</p>
  <p>因此，Sale VAT - 0 = Sale VAT (通常Sale VAT由亚马逊在销售发生后自动进行代缴),即不用退税或补税；</p><br>
  <p>非正常情况时, 销售价将低于或等于商品入口申请价值（例如产品滞销，折价或亏本销售）</p>
  <p>"Sale VAT=Sale Price * VAT Rating" 小于 "Import VAT = Import Price * VAT Rating";</p>
  <p>由于Import VAT申请了递延，即缴纳的Import VAT=0；因此，需要补税:</p>
  <p>补税额= Import VAT - Sale VAT (通常Sale VAT由亚马逊在销售发生后自动进行代缴)；</p><br>
  <p style="font-weight: bold; color: #00a0c7;">第二种情况: 当货物入口关税Import VAT直接缴纳, 没有申请递延</p><br>
  <p>正常情况时, 销售价将高于商品入口申请价值；</p>
  <p>"Sale VAT=Sale Price * VAT Rating" 大于 "Import VAT = Import Price * VAT Rating";</p>
  <p>通常Sale VAT由亚马逊在销售发生后自动进行代缴；</p>
  <p>此时, 实际上重复缴纳VAT了，因此将进行退税：</p>
  <p>退税额=(Sale VAT+Import VAT) - Sale VAT = Import VAT. </p><br>
  <p>非正常情况时, 销售价将低于或等于商品入口申请价值（例如产品滞销，折价或亏本销售）</p>
  <p>"Sale VAT=Sale Price * VAT Rating" 小于 "Import VAT = Import Price * VAT Rating";</p>
  <p>通常Sale VAT由亚马逊在销售发生后自动进行代缴；</p>
  <p>此时, 实际上重复缴纳VAT了，因此将进行退税：</p>
  <p>退税额=(Sale VAT+Import VAT) -Import VAT = Sale VAT.</p>`
// 商品入口综合税输入框详情
let importTariffInputHtml0 =
  ` <p style="font-weight: bold">对于美国商品入口税费</p>
  <p>商品入口税费 = Import Duty(入口关税) + ADV(清关杂费)</p>
  <p>Import Duty = 货物申报价值 x 商品关税税率</p>
  <p>(备注: 对于美国亚马逊FBA物流包含"双清包税"服务时，即包括Import Duty(入口关税)及ADV(清关杂费)；包含"双清不包税"服务时, 即只包括ADV(清关杂费)但不包括Import Tariff(入口关税)；</p>
  <br>
  <p style="font-weight: bold">对于美国在商品销售环节税种 (注: 入口清关环节无需缴纳，销售环节才由买家承担，通常由亚马逊统一代缴)</p>
  <p>美国50个州在商品销售环节的税种名称无过多差异，核心分为销售与使用税、特殊命名税种和无州级销售相关税三类，具体如下：</p>
  <br>
  <p>1.绝大多数州（43个）：销售税与使用税(Sales and Use Tax)</p>
  <p>这是美国最普遍的销售环节税种名称，使用税作为销售税的补充，针对未缴销售税却投入使用的商品征收，税率与本州销售税一致。具体包括亚拉巴马州、加利福尼亚州、德克萨斯州、纽约州、内华达州等。比如加州州级基础销售税7.25%，内华达州州级基础税率6.85%，均会叠加地方税率。</p>
  <br>
  <p>2.三个州：特殊命名的销售相关税种</p>
  <p>这三个州的税种名义不同，但核心对应商品销售环节的税收，本质和销售税功能一致：</p>
  <br>
  <p>- 亚利桑那州：交易特许税（Transaction Privilege Tax, TPT），针对零售商经营权征税，商家需按销售额缴税，而非直接对消费者课税。</p>
  <p>- 夏威夷州：综合营业税（General Excise Tax, GET），针对卖方总收入计税，州级基础税率4%，覆盖商品销售等经营活动。</p>
  <p>- 新墨西哥州：总收入税（Gross Receipts Tax），零售商按经营总收入缴纳，不将买方列为法定纳税人。</p>
  <br>
  <p>3.四个州：无州级销售相关税种</p>
  <p>这四个州不设州级销售税或类似税种，且禁止地方征收相关销售类税，仅个别场景有特殊小额税费（非商品销售普遍税种）：阿拉斯加州、特拉华州、蒙大拿州、新罕布什尔州。其中阿拉斯加州虽无州级税，但部分地方会收小额地方销售税，其余三州全境内商品销售均无销售类税种。</p>`
let importTariffInputHtml1 =
  `<p style="font-weight: bold">对于加拿大商品入口税费</p>
  <p>商品入口税费 = Import Tariff(关税) + ADV(清关杂费)</p>
  <p>Import Tariff = 货物申报价值 x 商品关税税率</p>
  <p>(备注: 对于加拿大亚马逊FBA物流包含"双清包税"服务时，即包括Import Tariff(入口关税)及ADV(清关杂费)；包含"双清不包税"服务时, 即只包括ADV(清关杂费)但不包括Import Tariff(入口关税)；</p>
  <br>
  <p style="font-weight: bold">对于加拿大在商品销售环节税种 (注: 入口清关环节无需缴纳，销售环节才由买家承担，通常由亚马逊统一代缴)</p>
  <p>- GST(商品及服务税): 联邦层面统一税率5%, 适用于几乎所有商品和服务的销售, 由买家在购买时支付。</p>
  <p>- PST(省销售税): 仅不列颠哥伦比亚省, 马尼托巴省, 萨斯喀彻温省征收, 税率各省不同(如不列颠哥伦比亚省7%, 马尼托巴省7%),同样由买家在消费时承担。</p>
  <p>- HST（统一销售税）：新不伦瑞克省、纽芬兰与拉布拉多省、新斯科舍省、爱德华王子岛省将GST和PST合并征收，税率为13%（如安大略省曾为13%,后调整为13%的HST), 由买家支付。</p>`
let importTariffInputHtml2 =
  `<p style="font-weight: bold">对于入口英国的商品将产生入口税费(Import Duty):</p>
  <p>Import Duty = Import Tariff + Import VAT+ ADV (即: 入口税费 = 入口关税 + 入口增值税 + 清关杂费);</p>
  <p>①Import Tariff (入口关税）= 货物申报价值 x 商品关税率（由目的国海关根据实际商品最终确定关税率及货物申报价值);</p>
  <p>②Import VAT (入口增值税）=（货物申报价值 + CIF运费 + Import Tariff）x 20%;</p>
  <br>
  <p style="font-weight: bold">如果您是最终的亚马逊店铺卖家后续还将产生销售增值税(Sale VAT):</p>
  <p>③ Sale VAT (销售增值税) = [税后销售价格/(1+20%)]* 20%</p>
  <p>④实际需缴纳的增值税 = Sale VAT - Import VAT</p>
  <br>
  <p style="font-weight: bold">备注: </p>
  <p>1. 对于英国等欧洲亚马逊FBA物流渠道，如果物流包含"双清"服务，即包括ADV；</p>
  <p>2. 如果物流包含"双清及包税"服务，即包括Import Tariff及ADV);</p>
  <p>3. 入口清关时如符合条件可申请Import VAT递延, 即暂不缴纳Import VAT直至销售发生后缴纳: "实际VAT = Sale VAT - Import VAT" (如果之前申请了Import VAT递延,当时没有缴纳Import VAT, 即此时公式里的Import VAT=0; 如果之前已缴纳Import VAT, 根据实际数值代入以上公式计算"实际VAT"即可);</p>`
let importTariffInputHtml3 =
  `<p style="font-weight: bold">对于德国商品入口税费</p>
  <p>商品入口税费 = Import Duty + Import VAT + ADV(清关杂费)</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 19%   </p>
  <p>(备注: 对于德国等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0（德国等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
  <p style="font-weight: bold">对于德国实缴纳税额</p>
  <p>德国Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率19%）*税率19%；</p>
  <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 19%   </p>
  <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率19%）*税率19%       </p>`
let importTariffInputHtml4 =
  `<p style="font-weight: bold">对于法国商品入口税费</p>
  <p>商品入口税费 = Import Duty + Import VAT + ADV(清关杂费)</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 20%   </p>
  <p>(备注: 对于法国等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0（法国等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
  <p style="font-weight: bold">对于法国实缴纳税额</p>
  <p>法国Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率20%）*税率20%；</p>
  <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 20%   </p>
  <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率20%）*税率20%       </p>`
let importTariffInputHtml5 =
  `<p style="font-weight: bold">对于意大利商品入口关税</p>
  <p>商品入口支付 = Import Duty + Import VAT + ADV(清关杂费)</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 22%   </p>
  <p>(备注: 对于意大利等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口关税可视为0（意大利等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口关税"框输入实际关税总额，系统将自动分摊计算单位关税额)</p>
  <p style="font-weight: bold">对于意大利实缴纳税额</p>
  <p>意大利Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率22%）*税率22%；</p>
  <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 22%   </p>
  <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率22%）*税率22%       </p>`
let importTariffInputHtml6 =
  `<p style="font-weight: bold">对于西班牙商品入口税费</p>
  <p>商品入口税费 = Import Duty + Import VAT + ADV(清关杂费)</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 21%   </p>
  <p>(备注: 对于西班牙等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0（西班牙等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
  <p style="font-weight: bold">对于西班牙实缴纳税额</p>
  <p>西班牙Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率21%）*税率21%；</p>
  <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
  <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
  <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 21%   </p>
  <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率21%）*税率21%       </p>`
let importTariffInputHtml7 =
  `<p style="font-weight: bold">对于日本的商品入口税费</p>
  <br>
  <p>商品入口税费(Import Duty)=商品入口关税(Import Tariff) + 地方消费税(JCT) + 清关杂费</p>
  <p>① Import Tariff=商品入口申报价值* 商品关税税率(Import Tariff Rate)</p>
  <p>② JCT=(税后销售价格/(1+地方消费税税率7.8%）*地方消费税税率7.8%</p>
  <br>
  <p style="font-weight: bold">备注：</p>
  <p>1. 在逆算法下,商品入口申报价格=[(商品链接的销售价-销售佣金-FBA运费)/(1+关税税率)]/110%;</p>
  <p>2. 货物总申报价值 = 商品入口申报价值* 商品数量</p>
  <p>3. 日本国内对应的税种叫消费税 (JCT, Japanese Consumption Tax), 不叫GST或VAT;</p>`
let importTariffInputHtml8 =
  `<p style="font-weight: bold">对于澳洲商品入口税费：</p>
  <p>①Import Duty (商品入口税费)=Import Tariff (商品入口关税)+Import GST (入口商品及服务税)+ADV (清关杂费)</p>
  <p>②Import Tariff (商品入口关税)=货物FOB申报价值 × 商品关税税率 (Import Tariff Rate)</p>
  <p>③Import GST (入口商品与服务税)=(货物申报价值+CIF运费+Import Duty)×10%</p>
  <p>④Sale GST(销售商品与服务税)=【税后销售价格/(1+税率10%)】×税率10%</p>
  <br>
  <p style="font-weight: bold">备注：</p>
  <p>1. 澳洲GST是指商品及服务税，全国统一税率为10%；但由于Sale GST由亚马逊买家在购买商品时支付并由亚马逊向税局代缴，因此亚马逊卖家后续可向税局进行退税处理 (澳洲对于Import GST不进行递延，因此入口商品需要先支付Import Tariff及Import GST);</p>
  <p>2. 对于澳洲亚马逊FBA物流渠道通常包含双清服务,可忽略ADV(清关杂费)；当物流费用含双清及包税时,通常只指包括商品入口关税,但不包括入口商品及服务税(Import GST);</p>`
let importTariffInputHtml9 =
  `<p style="font-weight: bold">对于入口墨西哥的商品将产生入口税费(Import Duty):</p>
  <p>Import Duty = Import Tariff + Import IVA+ ADV (即: 入口税费 = 入口关税 + 入口增值税 + 清关杂费);</p>
  <p>①Import Tariff (入口关税) = 货物申报价值 x 商品关税率 (由目的国海关根据实际商品最终确定关税率及货物申报价值);</p>
  <p>②Import IVA (入口增值税) = (货物申报价值 + CIF运费 + Import Tariff) x 16%;</p>
  <br>
  <p style="font-weight: bold">如果您是最终的亚马逊店铺卖家后续还将产生销售增值税(Sale IVA):</p>
  <p>③ Sale IVA (销售增值税) = [税后销售价格/(1+16%)]* 16%</p>
  <p>④实际需缴纳的增值税 = Sale IVA - Import IVA</p>
  <br>
  <p style="font-weight: bold">备注：</p>
  <p>1.对于墨西哥亚马逊FBA物流渠道，如果物流包含"双清不包税"服务，即包括ADV;</p>
  <p>2.如果物流包含"双清及包税"服务，即包括Import Tariff及ADV);</p>
  <p>3.入口清关时如企业通过IMMEX计划，可申请Import IVA递延, 即暂不缴纳Import IVA直至销售发生后缴纳: "实际VAT = Sale IVA - Import IVA" (如之前申请了Import IVA递延,当时没有缴纳Import IVA, 即此时公式里的Import IVA=0; 如果之前已缴纳Import IVA, 根据实际数值代入以上公式计算"实际IVA"即可.</p>`

// 国家站点输入框选项
let countrySiteInputOptions = Object.keys(countrySite).map(key => countrySite[key].name)
  // ['美国站','加拿大站','英国站','德国站','法国站','意大利站','西班牙站','日本站','澳洲站', '墨西哥站'];
// 卖家账户类型输入框选项
let sellerTypeInputOptions = ['专业销售计划', '个人销售计划']
// 合仓设置输入框选项
let warehouseConfigurationInputOptions = ['已合仓', '未合仓']
// 商品分类输入框选项
let sortInputOptions = ['非服装,鞋靴，箱包分类', '服装，鞋靴，箱包分类']
// 计价单位输入框选项
let unitInputOptions = ['套', '个', '盒', '包', '袋', '支']
// 是否出口退税输入框选项
let xxtsInputOptions = ['是','否']
// 清关及缴税状况输入框选项
let sqbsInputOptions = ['双清包税','双清不包税']
// 货件分类
let logisticsSortInputOptions = sortInputOptions
// 收货国家
let receivingAddressInputOptions = countrySiteInputOptions.map(s => s.slice(0, -1))
// 产品状态
let logisticsStatusInputOptions = productStatusInputOptions
// 是否报关
let logisticsIsDeclareInputOptions = xxtsInputOptions
// 收汇代理公司
let collectionAgencyInputOptions = ['Payoneer','World First','Lianlian','Airwallex','Pingpong','iPayLinks','CoGoLinks','WindPayer','网易支付','其他支付']

// 税务弹窗备注文字
let taxDialogRemarkText1 = '(备注: 日本区别于欧盟，没有“Import VAT与“Sale VAT”，入口清关时需要预缴”商品入口关税 Import Duty”及“入口商品消费税(JCT)”)'
let taxDialogRemarkText2 = '(备注: 由于物流双清包税,以上两项税费由物流公司支付,因此这两项税费可视作为￥0.00; 另外日本区别于欧盟没有"Import VAT与"Sale VAT”)'
let taxDialogRemarkText3 = '(备注: 由于物流双清包税,“Import Duty”由物流公司支付，因此 这项税费可视为￥0.00; 另外，美国区别于欧盟，入口时不需要缴纳"Import VAT”等”Import Sale VAT")'
let taxDialogRemarkText4 = '(备注: 美国区别于欧盟，入口时不需要缴纳"Import VAT"等"Import Sales Tax"，只需缴纳"Import Duty")'
let taxDialogRemarkText5 = '(备注: 加拿大区别于欧盟，没有"Import VAT"与"Sale VAT"，入口时只需缴纳"Import Tariff")'
let taxDialogRemarkText6 = '(备注: 墨西哥区别于欧盟，没有"Import VAT"与"Sale VAT"，入口时只需缴纳"Import Tariff")'
let taxDialogRemarkText7 = '(说明: 1. Import  Tariff为入口固定税, 与退补税无关; 2. 在双清包税情况下, Import VAT由物流公司自行安排VAT税号进行代缴或申请递延；但这与您亚马逊的销售主体不一致，税务链条断裂，不能进行退税或补税，同时也会产生税务不合规风险; 因此，亚马逊卖家要根据自己实际情况, 确认亚马逊店铺所在的国家的税务要求，是否有年销售免税额，上限是多少等，再决定是否选择双清包税渠道)'
let taxDialogRemarkText8 = '(备注: 由于物流双清包税,“Import Tariff”由物流公司支付，因此 这项税费可视为￥0.00; 另外，加拿大区别于欧盟，没有"Import VAT”与”Sale VAT")'
let taxDialogRemarkText9 = '(备注: 由于物流双清包税,“Import Tariff”由物流公司支付，因此 这项税费可视为￥0.00; 另外，墨西哥区别于欧盟，没有"Import VAT”与”Sale VAT")'

// 保留小数点数位
const keepDecimalPoint = (num, decimal) => {
  let pow = Math.pow(10, decimal)
  let number = Math.round(num * pow) / pow
  return number.toFixed(decimal)
}

// 替换字符串
const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace)
}

// 行内元素 px 转 rem
const getScaleByUI = (px) => {
  if(/%/ig.test(px)){ // TODO 行内元素 % 处理
    return px
  }else{
    return (parseFloat(px) / 13) + 'rem'
  }
}

// 深拷贝
function deepClone(obj){
  if(obj === null || typeof obj !== 'object'){
    return obj
  }
  let copy = Array.isArray(obj) ? [] : {}
  for(let key in obj){
    if(Object.prototype.hasOwnProperty.call(obj, key)){
      copy[key] = deepClone(obj[key])
    }
  }
  return copy
}

// 深度合并对象
function deepMerge(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
}

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}


export default {
  countryCurrencyInvariant,
  countryAbbreviationInvariant,
  countryAbbreviationInvariantByFinancial,
  nationalCurrencyInvariant,
  lengthArrayInvariant,
  weightArrayInvariant,
  warehouseFee,
  europeIndexArray,
  europeAndAmericaIndexArray,
  aisaIndexArray,
  permissionNameObj,

  sellerTypeInputHtml,
  warehouseConfigurationInputHtml,
  otherFeeInputHtml,
  taxExpenseInputHtml,
  operatingAnnualInterestRateInputHtml,
  sellingPriceInputHtml,
  xxtsInputHtml,
  sqbsInputHtml,
  stockPriceInputHtml,
  stockNumInputHtml,
  domesticFreightInputHtml,
  internationFreightInputHtml,
  saleTaxInputHtml,
  sqrkgslInputHtml,
  advertisingFeeInputHtml,
  billingFeeInputHtml,
  drainageFeeInputHtml,
  salesCommissionInputHtml,
  operationCommissionInputHtml,
  commissionInputHtml,
  recoveryLossRateInputHtml,
  showSalesInputHtml,
  disposalNumInputHtml,
  returnNumInputHtml,
  dyqzycslInputHtml,
  positionDayInputHtml,
  dybpcslInputHtml,
  getAmazonSalesCommissionInputHtml,
  getLocalDeliveryFeeInputHtml,
  getStorageCostAllocationInputHtml,
  getWarehouseConsolidationSettingFeeInputHtml,
  getCollectionLossInputHtml,
  getFundOperationInterestInputHtml,
  getCostOfCommodityInvestmentInputHtml,
  getCommodityCollectionInputHtml,
  getActualSalesVolumeForTheMonthInputHtml,
  getMonthlySalesProfitMarginInputHtml,
  getMonthlyCostProfitMarginInputHtml,
  laborCostForStoreManagementInputHtml,
  getImportTariffsOnGoodsInputHtml,
  getSalesVATOnGoodsInputHtml,
  getCustomsClearanceMiscellaneousFeesInputHtml,
  getTaxRefundInputHtml,
  importTariffInputHtml0,
  importTariffInputHtml1,
  importTariffInputHtml2,
  importTariffInputHtml3,
  importTariffInputHtml4,
  importTariffInputHtml5,
  importTariffInputHtml6,
  importTariffInputHtml7,
  importTariffInputHtml8,
  importTariffInputHtml9,

  countrySite,
  countrySiteInputOptions,
  sellerTypeInputOptions,
  warehouseConfigurationInputOptions,
  sortInputOptions,
  unitInputOptions,
  xxtsInputOptions,
  sqbsInputOptions,
  logisticsSortInputOptions,
  receivingAddressInputOptions,
  productStatusInputOptions,
  logisticsStatusInputOptions,
  logisticsIsDeclareInputOptions,
  productStatusByLogistics,
  collectionAgencyInputOptions,

  taxDialogRemarkText1,
  taxDialogRemarkText2,
  taxDialogRemarkText3,
  taxDialogRemarkText4,
  taxDialogRemarkText5,
  taxDialogRemarkText6,
  taxDialogRemarkText7,
  taxDialogRemarkText8,
  taxDialogRemarkText9,

  keepDecimalPoint,
  replaceAll,
  getScaleByUI,
  deepClone,
  deepMerge
}
